import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Link } from 'react-router-dom';
import * as pickDropConfig from '../config/city.json';
import { useEffect, useState } from 'react';
import Select from "react-dropdown-select";
import * as _ from 'lodash';
import { SuperSEO } from "react-super-seo";
import getCars from '../config/selfDriveCars';
import { Fleet } from '../models/cars.model';
import getServices from '../config/services';
import { Helmet } from 'react-helmet';
import getLocations from '../config/locations';
import getSelfDriveBikes from '../config/selfDriveBikes';
import { FEATURE_FLAGS } from '../config/featureFlags';

import { getCanonicalUrl } from '../utils/domain';

function Index() {
    const [cities, setCities] = useState<any[]>([]),
        [selectedCity, setSelectedCity] = useState<any>(''),
        [pickupPoints, setPickupPoints] = useState<any[]>([]),
        [dropoffPoints, setDropoffPoints] = useState<any[]>([]),
        [selectedService, setSelectedService] = useState<string>('self driving car rental');

    const updateCitySelector = (serviceType: string) => {
        let cities = Object.keys(pickDropConfig);
        let selectCities: any[] = [];
        cities.forEach((city, index) => {
            if (city != 'default' && pickDropConfig[city as keyof typeof pickDropConfig].config.some((item: any) => item.service === _.startCase(serviceType)))
                selectCities.push({ id: index, name: city })
        })
        setCities(selectCities);
    }

    useEffect(() => {
        window.scrollTo(0, 0)
        updateCitySelector(selectedService);
    }, [])

    const getCharges = (vehicle: Fleet) => {
        return vehicle.Charges.length > 1 ? `${vehicle.Charges[0].toString()}*` : vehicle.Charges[0].toString()
    }
    const getKMs = (vehicle: Fleet) => {
        return vehicle.KMIncluded!.length > 1 ? `${vehicle.KMIncluded![0]}*` : vehicle.KMIncluded![0];
    }
    const getExtraKMCharges = (vehicle: Fleet) => {
        return vehicle.ExtraKMCharges.length > 1 ? `${vehicle.ExtraKMCharges[0]}*` : vehicle.ExtraKMCharges[0]
    }

    const onServiceChange = (serviceType: string) => {
        updateCitySelector(serviceType);
        setSelectedService(serviceType);
    }

    function onCitySelected(city: any) {
        let pickupPoints: any[] = [], dropoffPoints: any[] = [];
        pickDropConfig[city as keyof typeof pickDropConfig].config.forEach((config) => {
            config.pickup.forEach((pickup, index) => {
                pickupPoints.push({ id: index, name: pickup })
            });
            config.dropoff.forEach((dropoff, index) => {
                dropoffPoints.push({ id: index, name: dropoff })
            });
        });
        setPickupPoints(pickupPoints);
        setDropoffPoints(dropoffPoints);
    }
    return (
        <>
            <Helmet>
                <link rel="canonical" href={getCanonicalUrl('/')} />
            </Helmet>
            <SuperSEO
                title="Aapli Gaadi - Self-Drive & Chauffeur-Driven Car Rentals Across Maharashtra"
                description="Aapli Gaadi offers self-drive and chauffeur-driven car rentals in Mumbai, Navi Mumbai, Thane, Kudal, Kankavli, Vaibhavwadi, Sawantwadi, Vengurla, Malvan, Tarkarli, Kunkeshwar, Devgad, Devbag, Ratnagiri, and Ganpatipule. Book your ride today for a hassle-free travel experience!"
                lang="en"
                openGraph={{
                    ogTitle: "Aapli Gaadi - Car Rentals Across Maharashtra",
                    ogDescription:
                        "Rent self-drive or chauffeur-driven cars across Mumbai, Navi Mumbai, Thane, and Konkan region. Affordable and hassle-free travel solutions.",
                    ogUrl: getCanonicalUrl('/'),
                    ogType: "website",
                    ogSiteName: "Aapli Gaadi",
                    ogLocale: "en_US"
                }}
            />
            <div className="hero-wrap " style={{ backgroundImage: `url('/image/aapli_gaadi_landing.png')` }} data-stellar-background-ratio="0.5">

                <div className="container">
                    <div className="row no-gutters slider-text justify-content-start align-items-center justify-content-center">
                        <div className="col-lg-8 ">
                            <div className="text w-100 text-center mb-md-5 pb-md-5">
                                <h1 className="mb-4" style={{
                                    background: 'linear-gradient(90deg, #ffbb00 0%, #ff3c3c 30%, #ff73fa 60%, #ffe426 80%, #ff6400 100%)',
                                    backgroundSize: '200%',
                                    backgroundClip: 'text',
                                    WebkitBackgroundClip: 'text',
                                    color: 'transparent',
                                    animation: 'move-gradient 3s ease-in-out infinite alternate'
                                }}>Fast &amp; Easy Way To Rent A Car</h1>
                                <p style={{ fontSize: '18px' }}>
                                    Explore the unexplored with <a href='https://www.aapligaadi.co.in' target={'_self'}>Aapli Gaadi</a>. Choose from wide range of cars.
                                </p>
                                <br />
                                <h2 className='playwrite-cu-font' style={{
                                    fontSize: '55px',
                                    background: 'linear-gradient(90deg, #FF5EDF 0%, #04C8DE 25%, #FFFB7D 50%, #FF88AC 75%, #43ff64 100%)',
                                    backgroundSize: '200%',
                                    backgroundClip: 'text',
                                    WebkitBackgroundClip: 'text',
                                    color: 'transparent',
                                    animation: 'move-gradient 3s ease-in-out infinite alternate'
                                }}>Explore the unexplored...</h2>
                                {/* <a href="https://vimeo.com/45830194" className="icon-wrap popup-vimeo d-flex align-items-center mt-4 justify-content-center">
                                    <div className="icon d-flex align-items-center justify-content-center">
                                        <span className="ion-ios-play"></span>
                                    </div>
                                    <div className="heading-title ml-5">
                                        <span>Easy steps for renting a car</span>
                                    </div>
                                </a> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="ftco-section ftco-no-pt bg-light">
                <div className="container">
                    <div className="row no-gutters">
                        <div className="col-md-12 featured-top">
                            <div className="row no-gutters justify-content-center">
                                <div className="col-lg-10 col-md-12 d-flex align-items-center" id="select-city">
                                    <div className="services-wrap rounded w-100">
                                        <h3 className="heading-section text-center mb-4">Search & Find Your Perfect Ride</h3>
                                        <div className='row mb-3 justify-content-center' onChange={(e) => { onServiceChange((e.target as HTMLInputElement).value) }} >
                                            <div className='col-lg-3 col-md-6 col-sm-6 col-xs-12 p-2'>
                                                <label className={`service-tab-pill ${selectedService === 'self driving car rental' ? 'active' : ''}`}>
                                                    <input type={'radio'} value="self driving car rental" name="service_type" checked={selectedService === 'self driving car rental'} onChange={() => { }}></input>
                                                    Self Drive Car
                                                </label>
                                            </div>
                                            {FEATURE_FLAGS.ENABLE_EXTRA_FEATURES && (
                                                <div className='col-lg-3 col-md-6 col-sm-6 col-xs-12 p-2'>
                                                    <label className={`service-tab-pill ${selectedService === 'tour packages' ? 'active' : ''}`}>
                                                        <input type={'radio'} value="tour packages" name="service_type" checked={selectedService === 'tour packages'} onChange={() => { }}></input>
                                                        Tour Packages
                                                    </label>
                                                </div>
                                            )}
                                            <div className='col-lg-3 col-md-6 col-sm-6 col-xs-12 p-2'>
                                                <label className={`service-tab-pill ${selectedService === 'self driving bike rental' ? 'active' : ''}`}>
                                                    <input type={'radio'} value="self driving bike rental" name="service_type" checked={selectedService === 'self driving bike rental'} onChange={() => { }}></input>
                                                    Self Drive Bike
                                                </label>
                                            </div>
                                            <div className='col-lg-3 col-md-6 col-sm-6 col-xs-12 p-2'>
                                                <label className={`service-tab-pill ${selectedService === 'car rental' ? 'active' : ''}`}>
                                                    <input type={'radio'} value="car rental" name="service_type" checked={selectedService === 'car rental'} onChange={() => { }}></input>
                                                    Car With Driver
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row align-items-end justify-content-center mt-4">
                                            <div className="col-md-6 col-12 mb-3 mb-md-0">
                                                <label className="label text-dark font-weight-bold mb-2" style={{ fontSize: '13px', display: 'block' }}>Select City / Hub</label>
                                                <Select values={[]} labelField='name' searchable={true} valueField='name' options={cities} onChange={(values) => setSelectedCity(values[0]?.name || '')} placeholder="Search your location..." />
                                            </div>
                                            <div className="col-md-4 col-12 d-flex align-items-end">
                                                <Link to={selectedCity ? `/services/${selectedService.toLowerCase().replaceAll(' ', '-')}/${selectedCity.toLowerCase().replaceAll(' ', '-')}` : '#'} className="btn btn-primary btn-block text-center py-2 font-weight-bold" style={{ height: '48px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px', fontSize: '15px' }}>
                                                    {selectedService === 'tour packages' ? 'Find Tour Packages' : 'Find Your Perfect Car'}
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ftco-section bg-light pt-5">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-md-7 text-center heading-section">
                            <span className="subheading">How it works</span>
                            <h2 className="mb-2">3 Simple Steps to Rent</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 d-flex align-self-stretch">
                            <div className="services w-100 text-center p-4 bg-white rounded shadow-sm hover-lift" style={{ border: '1px solid #e2e8f0', transition: 'var(--transition)' }}>
                                <div className="icon d-flex align-items-center justify-content-center mb-4" style={{ width: '80px', height: '80px', backgroundColor: '#fff7ed', borderRadius: '50%', margin: '0 auto' }}>
                                    <span className="flaticon-route" style={{ fontSize: '32px', color: 'var(--primary-color)' }}></span>
                                </div>
                                <div className="text w-100">
                                    <h3 className="heading mb-2 font-weight-bold" style={{ fontSize: '18px' }}>Choose Location</h3>
                                    <p style={{ fontSize: '14px' }}>Select from our widespread network of pick-up and drop-off hubs across Maharashtra and Konkan.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 d-flex align-self-stretch">
                            <div className="services w-100 text-center p-4 bg-white rounded shadow-sm hover-lift" style={{ border: '1px solid #e2e8f0', transition: 'var(--transition)' }}>
                                <div className="icon d-flex align-items-center justify-content-center mb-4" style={{ width: '80px', height: '80px', backgroundColor: '#e6fffa', borderRadius: '50%', margin: '0 auto' }}>
                                    <span className="flaticon-handshake" style={{ fontSize: '32px', color: 'var(--secondary-color)' }}></span>
                                </div>
                                <div className="text w-100">
                                    <h3 className="heading mb-2 font-weight-bold" style={{ fontSize: '18px' }}>Select Best Deal</h3>
                                    <p style={{ fontSize: '14px' }}>Compare affordable tariffs, choose your preferred vehicle model, and pick from flexible kilometer options.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 d-flex align-self-stretch">
                            <div className="services w-100 text-center p-4 bg-white rounded shadow-sm hover-lift" style={{ border: '1px solid #e2e8f0', transition: 'var(--transition)' }}>
                                <div className="icon d-flex align-items-center justify-content-center mb-4" style={{ width: '80px', height: '80px', backgroundColor: '#eff6ff', borderRadius: '50%', margin: '0 auto' }}>
                                    <span className="flaticon-rent" style={{ fontSize: '32px', color: '#3b82f6' }}></span>
                                </div>
                                <div className="text w-100">
                                    <h3 className="heading mb-2 font-weight-bold" style={{ fontSize: '18px' }}>Reserve Your Car</h3>
                                    <p style={{ fontSize: '14px' }}>Confirm your booking online with zero hassle and get ready to explore the unexplored parts of Konkan.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="ftco-section ftco-no-pt bg-light">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12 heading-section text-center  mb-5">
                            <span className="subheading">What we offer</span>
                            <h2 className="mb-2">Vehicles Offered</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <OwlCarousel className="carousel-car owl-carousel" autoPlay={true} autoplayTimeout={2000} items={3} responsive={{ 0: { items: 1 }, 450: { items: 2 }, 600: { items: 2 }, 1000: { items: 3 } }}>
                                {
                                    getCars().map((vehicle: Fleet, idx: number) => {
                                        const serviceTypeSlug = vehicle.isSelfDrive ? 'self-driving-car-rental' : 'chauffeur-driven-car-rental';
                                        const locationSlug = _.kebabCase(vehicle.Locations[0]);
                                        const vSlug = _.kebabCase(`${vehicle.Brand}-${vehicle.Name}-${vehicle.isSelfDrive ? 'self-drive' : 'with-driver'}`);
                                        return (
                                            <div className="item" style={{ padding: '2%' }} key={`car-${idx}`}>
                                                <div className="car-wrap rounded ">
                                                    <div className="img rounded d-flex align-items-end" style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/image/cars/${vehicle.Image}')`, backgroundSize: 'contain', backgroundPosition: 'center' }}>
                                                    </div>
                                                    <div className="text">
                                                        <h2 className="mb-0">
                                                            <Link to={`/services/${serviceTypeSlug}/${locationSlug}/${vSlug}`}>
                                                                {vehicle.Name}
                                                            </Link>
                                                        </h2>
                                                        <span>{vehicle.Details.Fuel}</span>
                                                        <div className="d-flex">
                                                            <span className="cat">{vehicle.Brand}</span>
                                                            <p className="price ml-auto">{getCharges(vehicle)} <span>/{vehicle.UOM}</span></p>
                                                        </div>
                                                        <div className="d-flex mb-3">
                                                            <span className="cat">{getKMs(vehicle)} KMs</span>
                                                            <p className="price ml-auto"><span>Extra Kilometer Charges: {getKMs(vehicle) === 'Unlimited' ? 'N/A' : `${getExtraKMCharges(vehicle)} / KM`}</span></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                }{getSelfDriveBikes().map((vehicle: Fleet, idx: number) => {
                                    const serviceTypeSlug = 'self-driving-bike-rental';
                                    const locationSlug = _.kebabCase(vehicle.Locations[0]);
                                    const vSlug = _.kebabCase(`${vehicle.Brand}-${vehicle.Name}-${vehicle.isSelfDrive ? 'self-drive' : 'with-driver'}`);
                                    return (
                                        <div className="item" style={{ padding: '2%' }} key={`bike-${idx}`}>
                                            <div className="car-wrap rounded ">
                                                <div className="img rounded d-flex align-items-end" style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/image/bikes/${vehicle.Image}')`, backgroundSize: 'contain', backgroundPosition: 'center' }}>
                                                </div>
                                                <div className="text">
                                                    <h2 className="mb-0">
                                                        <Link to={`/services/${serviceTypeSlug}/${locationSlug}/${vSlug}`}>
                                                            {vehicle.Name}
                                                        </Link>
                                                    </h2>
                                                    <span>{vehicle.Details.Fuel}</span>
                                                    <div className="d-flex">
                                                        <span className="cat">{vehicle.Brand}</span>
                                                        <p className="price ml-auto">{getCharges(vehicle)} <span>/{vehicle.UOM}</span></p>
                                                    </div>
                                                    <div className="d-flex mb-3">
                                                        <span className="cat">{getKMs(vehicle)} KMs</span>
                                                        <p className="price ml-auto"><span>Extra Kilometer Charges: {getKMs(vehicle) === 'Unlimited' ? 'N/A' : `${getExtraKMCharges(vehicle)} / KM`}</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                                }

                            </OwlCarousel>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ftco-section ftco-no-pt bg-light">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12 heading-section text-center  mb-5">
                            <span className="subheading">Our Presence</span>
                            <h2 className="mb-2">We Offer Services In</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <OwlCarousel className="carousel-car owl-carousel" autoPlay={true} autoplayTimeout={2000} items={5} responsive={{ 0: { items: 1 }, 450: { items: 3 }, 600: { items: 3 }, 1000: { items: 5 } }}>
                                {
                                    getLocations().map((location: any, idx: number) => <div className="item" style={{ padding: '2%' }}>
                                        <div className="car-wrap rounded " key={idx}>
                                            <div className="img rounded d-flex align-items-end" style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/image/locations/${location.image}')`, backgroundSize: 'contain', backgroundPosition: 'center' }}>
                                            </div>
                                        </div>
                                    </div>)
                                }

                            </OwlCarousel>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ftco-section ftco-about">
                <div className="container">
                    <div className="row no-gutters">
                        <div className="col-md-6 p-md-5 img img-2 d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}'/image/car-rental.jpeg')` }}>
                        </div>
                        <div className="col-md-6 wrap-about ">
                            <div className="heading-section pl-md-5">
                                <span className="subheading">About us</span>
                                <h2 className="mb-4">Welcome to <a href='https://www.aapligaadi.co.in' target={'_self'}>Aapli Gaadi</a></h2>

                                <p> <a href='https://www.aapligaadi.co.in' target={'_self'}>Aapli Gaadi</a>  is a marketplace for cars on rent originated from Konkan region of Maharashtra. From short road trips to quick near city drives for supply pick-up, regional food runs, we have the cheapest car rental options for all your needs!</p>
                                <p>An economical hatchback for narrow roads, a sedan for short trips, SUV for hills and all for exploring the unexplored Konkan Coastal Region.</p>
                                <p>With  <a href='https://www.aapligaadi.co.in' target={'_self'}>Aapli Gaadi</a> , you can experience the convenience of online booking. The cars listed on our platform come with vehicle insurance. It is extremely easy to pick up the car from the host location. You can select from flexible KMs, transparent pricing, and 24/7 Roadside Assistance. Car rent per KM starts as low as Rs. 1200/day. From short road trips to quick in-city drives for groceries, supply pick-up, meeting friends and family, doctor visits, business trips, we have the cheapest car rental options for all your needs! </p>
                                <p><a href='#select-city' className="btn btn-primary py-3 px-4">Search AapliGaadi</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ftco-section bg-light">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-md-7 text-center heading-section ">
                            <span className="subheading">More about Aapli Gaadi</span>
                            <h2 className="mb-3">Highlights</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3" key={`Since`}>
                            <div className="services services-2 w-100 text-center">
                                <div className="icon d-flex align-items-center justify-content-center">
                                    <span> 2022</span>
                                </div>
                                <div className="text w-100">
                                    <h3 className="heading mb-2">Since</h3>
                                    <p style={{ textAlign: 'justify' }}>
                                        Since 2022, Aapli Gaadi has been providing reliable car rental and self-drive services, ensuring a seamless travel experience for our customers.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3" key={`Locations`}>
                            <div className="services services-2 w-100 text-center">
                                <div className="icon d-flex align-items-center justify-content-center">
                                    <span> {
                                        Object.keys(pickDropConfig).length - 1
                                    }</span>
                                </div>
                                <div className="text w-100">
                                    <h3 className="heading mb-2">Locations</h3>
                                    <p style={{ textAlign: 'justify' }}>
                                        Aapli Gaadi serves {
                                            Object.keys(pickDropConfig).length - 1
                                        } cities, providing self-drive rentals, chauffeur-driven cars, and flexible monthly subscriptions for a convenient and hassle-free travel experience.


                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3" key={`happy-customers`}>
                            <div className="services services-2 w-100 text-center">
                                <div className="icon d-flex align-items-center justify-content-center">
                                    <span> 299+</span>
                                </div>
                                <div className="text w-100">
                                    <h3 className="heading mb-2">Happy Customers</h3>
                                    <p style={{ textAlign: 'justify' }}>
                                        Aapli Gaadi has proudly served 299+ satisfied customers with our self-drive car rentals, chauffeur-driven services, and flexible monthly subscriptions.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3" key={`Fleet`}>
                            <div className="services services-2 w-100 text-center">
                                <div className="icon d-flex align-items-center justify-content-center">
                                    <span> 50+</span>
                                </div>
                                <div className="text w-100">
                                    <h3 className="heading mb-2">Fleet</h3>
                                    <p style={{ textAlign: 'justify' }}>
                                        Aapli Gaadi offers a diverse fleet of 50+ cars, ensuring a hassle-free experience for self-drive rentals, chauffeur-driven services, and flexible monthly subscriptions to suit your travel needs.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="ftco-section">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-md-7 text-center heading-section ">
                            <span className="subheading">Services</span>
                            <h2 className="mb-3">Our Latest Services</h2>
                        </div>
                    </div>
                    <div className="row">
                        {
                            getServices().map((service, index) => {
                                return (
                                    <>
                                        <div className="col-md-3" key={`aapli-gaadi-service-${index}`}>
                                            <div className="services services-2 w-100 text-center">
                                                <div className="icon d-flex align-items-center justify-content-center">
                                                    <span className={service.icon}></span>
                                                </div>
                                                <div className="text w-100">
                                                    <h3 className="heading mb-2">{service.heading}</h3>
                                                    <p>{service.description}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </>

                                )
                            })
                        }
                    </div>
                </div>
            </section>

            <section className="ftco-section ftco-no-pt ftco-no-pb bg-light my-5">
                <div className="container">
                    <div 
                        className="p-5 rounded shadow-lg text-white" 
                        style={{ 
                            background: `linear-gradient(rgba(15, 23, 42, 0.8), rgba(15, 23, 42, 0.8)), url('${process.env.PUBLIC_URL}/image/driver.webp')`, 
                            backgroundSize: 'cover', 
                            backgroundPosition: 'center',
                            borderRadius: '20px'
                        }}
                    >
                        <div className="row align-items-center">
                            <div className="col-md-8">
                                <h2 className="text-white font-weight-bold mb-3" style={{ fontSize: '32px' }}>Do You Want To Earn With Us?</h2>
                                <p className="text-light mb-0" style={{ fontSize: '16px', opacity: 0.9 }}>Host your car or join our partner network to start earning monthly passive income with Aapli Gaadi.</p>
                            </div>
                            <div className="col-md-4 text-md-right mt-4 mt-md-0">
                                <Link to={'/join-us'} className="btn btn-primary py-3 px-5 text-uppercase font-weight-bold" style={{ borderRadius: '30px', border: 'none' }}>Join Us Now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ftco-section testimony-section bg-light">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-md-7 text-center heading-section ">
                            <span className="subheading">Benefits of choosing <a href='https://www.aapligaadi.co.in' target={'_self'}>Aapli Gaadi</a></span>
                            <h2 className="mb-3">Benefits</h2>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-12">
                            <OwlCarousel className="carousel-testimony owl-carousel ftco-owl" items={3} responsive={{ 0: { items: 1 }, 450: { items: 2 }, 600: { items: 3 }, 1000: { items: 3 } }}>
                                <div className="item" key={11}>
                                    <div className="testimony-wrap rounded text-center py-4 pb-5">
                                        <div className="text pt-4">
                                            <p className="name">Drive It Anywhere!</p>
                                            <p className="mb-4">
                                                <a href='https://www.aapligaadi.co.in' target={'_self'}>Aapli Gaadi</a> provides comfortable vehicles for you to take your friends and family on trip!
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="item" key={12}>
                                    <div className="testimony-wrap rounded text-center py-4 pb-5">
                                        <div className="text pt-4">
                                            <p className="name">Low security deposite!</p>
                                            <p className="mb-4">
                                                We trust in our clients! Here at <a href='https://www.aapligaadi.co.in' target={'_self'}>Aapli Gaadi</a>, we provide vehicles with MINIMUM security deposites.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="item" key={13}>
                                    <div className="testimony-wrap rounded text-center py-4 pb-5">
                                        <div className="text pt-4">
                                            <p className="name">Flexible Kilometers</p>
                                            <p className="mb-4">All vehicles @ <a href='https://www.aapligaadi.co.in' target={'_self'}>Aapli Gaadi</a> comes with this feature of flexible kilometers for daily self driving rental solutions.</p>
                                        </div>
                                    </div>
                                </div>
                            </OwlCarousel>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Index